module.exports = __webpack_public_path__ + "media/31.24133c47.mp3";